import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import UserAddressService from "../../services/useraddress/useraddress.service";
import AreaPincodeSearch from "./areaPincode-search";
import AreaPincodeDataTable from "./areaPincode-datatable";
import { PincodeAreaModel } from "../../models/cust-address/cust-address-model";
import AppLoading from '../app-loading/app-loading';
import { Toast } from 'primereact/toast';

const AddAreaPincodeMain: React.FC = () => {
  const { t } = useTranslation();
  const [areaList, setAreaList] = useState<PincodeAreaModel[]>([]);  
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState<number>(0);  
  const [pageNumber, setPageNumber] = useState<number>(1);  
  const [pageSize, setPageSize] = useState<number>(10); 
  const [filter, setFilter] = useState<any>();
  const [searchTerm, setSearchTerm] = useState<any>();
  const toast = useRef<Toast>(null);

  const reloadPage = (val: boolean) => {
    if (val) {
      fetchData(pageNumber, pageSize);
    }
  };

  const fetchData = async (pageNumber: any, pageSize: any) => {
    setLoading(true);
    try {
      const response = await UserAddressService.getAllPincodeArea(pageNumber, pageSize);
      setAreaList(response.areas);  
      setTotalRecords(response.totalRecords);  
    } catch (error) {
      console.error("Error fetching data:", error);
      setAreaList([]);  
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = async (event: any) => {
    setLoading(true);
    try {
      const newPageNumber = Math.floor(event.first / event.rows) + 1;
      setPageNumber(newPageNumber);
      setPageSize(event.rows);
      
      const response = await UserAddressService.searchFilterPincode(
        filter, 
        searchTerm, 
        newPageNumber, 
        event.rows
      );
      setAreaList(response.areas);
      setTotalRecords(response.totalRecords);
    } catch (error) {
      console.error("Error handling page change:", error);
      toast.current?.show({
        severity: 'error',
        summary: 'Error',
        detail: 'Failed to load data',
        life: 3000
      });
    } finally {
      setLoading(false); 
    }
  };

  return (
    <>
      <div className="layout-content mt-3 mb-3 grid grid-table-mobile">
        <div className="col-12">
          <h5 className="ml-1 mb-0">{"Area & Pincode"}</h5>
        </div>

        <AreaPincodeSearch 
          reloadPage={reloadPage} 
          setLoading={setLoading} 
          setPageNumber={setPageNumber} 
          setPageSize={setPageSize}
          setAreaList={setAreaList} 
          setTotalRecords={setTotalRecords}
          setSearchTerm={setSearchTerm} 
        />

        <AreaPincodeDataTable 
          data={areaList} 
          NoofRecords={totalRecords} 
          pageNumber={pageNumber} 
          pageSize={pageSize} 
          searchTerm={searchTerm}
          onPageChange={handlePageChange}
          toastRef={toast}
          refreshData={() => fetchData(pageNumber, pageSize)}
        />
      </div>
      
      {loading && <AppLoading />}
      <Toast ref={toast} />
    </>
  );
};

export default AddAreaPincodeMain;
